import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useGetAssignmentQuestionIdsByStandardMutation,useGetPublicAssignmentQuestionIdsByStandardMutation } from '../../../features/authentication/assignmentApislice';
import CustomToast from '../../../components/Toast';
import Modal from '../../../components/Modal';
import QuestionPreviewModal from './QuestionPreviewModal';

const PublicAssignmentPropertiesTable = ({ publicArray, tableHead, loading, assignmentId, isPublicAssignment }) => {

  const [getAssignmentQuestionIds] = useGetAssignmentQuestionIdsByStandardMutation();
  const [getPublicAssignmentQuestionIds] = useGetPublicAssignmentQuestionIdsByStandardMutation();
  const [standardQuestions, setStandardQuestions] = React.useState([]);
  const [openQuestionIdsByStandardModal, setOpenQuestionIdsByStandardModal] = React.useState(false);
  const [openQuestionDetailModel, setOpenQuestionDetailModel] = React.useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = React.useState(null);

  const handleStandard= async (standardNumber) =>{
    const options = {
      standardNumber:standardNumber,
      assignmentId: assignmentId,
    };
    let response={};
    if(isPublicAssignment)
      response = await getPublicAssignmentQuestionIds(options);
    else
      response = await getAssignmentQuestionIds(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      setStandardQuestions(response.data);
      setOpenQuestionIdsByStandardModal(true);
    }
  };
  
  const handleQuestionDetails=(questionId) => {
    setSelectedQuestionId(questionId);
    setOpenQuestionDetailModel(true);
  };

  return (
    <>
      <div className="custom-table table-responsive public-assignment-table">
        <table className="table">
          <thead>
            <tr>
              <th>{tableHead}</th>
              <th>Count</th>
              <th>Percentage</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <>
                {[...Array(3)].map((_, index) => (
                  <tr key={index}>
                    {[...Array(3)].map((_, index) => (
                      <td key={`load-${index}`}>
                        <Skeleton />
                      </td>
                    ))}
                  </tr>
                ))}
              </>
            ) : (
              publicArray?.map((value, index) => (
                <tr key={`${tableHead}-table-${index}`}>
                  <td> {value.name}</td>
                  <td className={tableHead ==='Standard'?'cursor-pointer text-decoration-underline text-castleRed':''} onClick={()=>tableHead ==='Standard'?handleStandard(value.standardNumber):''}> {value.count} </td>
                  <td> {value.percentage}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      
      <Modal
        contentWidth="500px"
        isOpen={openQuestionIdsByStandardModal}
        titleName='Questions'
        onClose={() => setOpenQuestionIdsByStandardModal(false)}>
        <div className="questions-numbers-list edit flex-shrink-0">
          <ul className='d-flex flex-wrap gap-2'>
            {standardQuestions.map((item, index) => {
              return (
                <li
                  onClick={()=>handleQuestionDetails(item.questionId)}
                  key={`questionButton-${index}`}
                  className='cursor-pointer question-list-item'
                >
                  {item.questionIndex}
                </li>
              );
            })}
          </ul>
        </div>
      </Modal> 
      <QuestionPreviewModal
        isOpen={openQuestionDetailModel}
        onClose={() => setOpenQuestionDetailModel(false)}
        questionId={selectedQuestionId}
        assignmentId={parseInt(assignmentId)}
        isPublicAssignment={isPublicAssignment}
      />
    </>
  );
};

PublicAssignmentPropertiesTable.propTypes = {
  publicArray: PropTypes.array,
  loading: PropTypes.bool,
  tableHead: PropTypes.string,
  assignmentId: PropTypes.number,
  isPublicAssignment: PropTypes.bool,
};

export default PublicAssignmentPropertiesTable;
